import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ASSETS } from "@/lib/brand";

export const LegalLayout = ({ title, subtitle, children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const prev = document.title;
    document.title = `${title} · Pinguin Paula`;
    return () => {
      document.title = prev;
    };
  }, [title]);

  return (
    <div className="min-h-screen bg-paula-cream">
      {/* Minimal header */}
      <header className="border-b border-slate-200 bg-white/70 backdrop-blur">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-home-link"
            className="flex items-center gap-3 group"
          >
            <div className="w-9 h-9 rounded-full bg-white border border-slate-200 grid place-items-center overflow-hidden">
              <img
                src={ASSETS.paulaCharacter}
                alt="Paula"
                className="w-8 h-8 object-contain"
              />
            </div>
            <div className="leading-tight">
              <div className="font-display font-bold text-paula-ink text-sm">
                Pinguin Paula
              </div>
              <div className="text-[10px] uppercase tracking-widest text-paula-muted">
                Bleib cool
              </div>
            </div>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-paula-ink/80 hover:text-paula-red transition-colors"
          >
            <ArrowLeft size={16} />
            Zurück zur Startseite
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-16 sm:py-24">
        <div className="mb-12">
          <div className="text-xs font-semibold uppercase tracking-[0.2em] text-paula-red mb-4">
            Rechtliches
          </div>
          <h1 className="font-display font-bold text-4xl sm:text-5xl text-paula-ink leading-[1.05] tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-4 text-paula-muted text-lg">{subtitle}</p>
          )}
        </div>
        <article className="prose-content text-paula-ink/90 leading-relaxed">
          {children}
        </article>
      </main>
    </div>
  );
};

export default LegalLayout;
